import React, { useEffect, useState, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/JobModalCss.css';
import { Button, Modal, Form, Row, Col } from 'react-bootstrap';
import { createDeviceModel, getAllCatalogs, updateDeviceModel, deleteDeviceModelById, getCategoriesByCatalogId, getDeviceModelGroupsByCategoryId, getAllDevicePolicies, getAllDeviceGroups, getAllDeviceModels } from '../commonApi';
import ActionCell from '../Utils/ActionCell';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Loader } from '../Loader';
import AsyncSelect from 'react-select/async';
import moment from 'moment';

const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func(...args), delay);
    };
};

const DeviceModel = () => {
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [sortField, setSortField] = useState('createdDate');
    const [sortOrder, setSortOrder] = useState('desc');
    const [totalRows, setTotalRows] = useState(0);
    const [deviceModels, setDeviceModels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [name, setName] = useState('');
    const [typeSlug, setTypeSlug] = useState('');
    const [description, setDescription] = useState('');
    const [uidPrefix, setUidPrefix] = useState('');
    const [selectedPolicyIds, setSelectedPolicyIds] = useState([]);
    const [selectedGroupIds, setSelectedGroupIds] = useState([]);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [selectedPolicies, setSelectedPolicies] = useState([]);
    const [selectedCatalogId, setSelectedCatalogId] = useState('');
    const [selectedCategoryId, setSelectedCategoryId] = useState('');
    const [groupId, setGroupId] = useState('');
    const [catalogs, setCatalogs] = useState([]);
    const [catalogsName, setCatalogsName] = useState('');
    const [categoryName, setCategoryName] = useState('');
    const [modelGroupName, setModelGroupName] = useState('');
    const [categories, setCategories] = useState([]);
    const [modelGroups, setModelGroups] = useState([]);
    const [groups, setGroups] = useState([]);
    const [policies, setPolicies] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [currentModelId, setCurrentModelId] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [validationErrors, setValidationErrors] = useState({
        name: '',
        typeSlug: '',
        description: '',
        uidPrefix: '',
        groupId: '',
        policyIds: '',
        groupIds: '',
        vendorId: '',
        productId: ''
    });
    const [isSaveDisabled, setIsSaveDisabled] = useState(false);
    const [isDeleteDisabled, setIsDeleteDisabled] = useState(false);
    const saveButtonRef = useRef(null);
    const expectedPageRef = useRef(0);
    const [groupsPageSize] = useState(1000);
    const [policiesPageSize] = useState(10);
    const [groupsLoading, setGroupsLoading] = useState(false);
    const [policiesLoading, setPoliciesLoading] = useState(false);
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const [vendorId, setVendorId] = useState('');
    const [productId, setProductId] = useState('');
    const [isHubRequired, setIsHubRequired] = useState(false);
    const [chime_compatible, setchime_compatible] = useState(false);
    const [group_compatible, setgroup_compatible] = useState(false);
    const [scene_compatible, setscene_compatible] = useState(false);
    const renderActionCell = (row) => {
        return <ActionCell row={row} onEdit={handleEditClick} onDelete={handleDeleteClick} />;
    };

    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            sortField: 'name',
            width: '200px',
            cell: (row) => (
                <div
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={row?.name || ""}
                >
                    {row?.name && row.name.length > 20
                        ? `${row.name.substring(0, 20)}...`
                        : row?.name || ""}
                </div>
            ),
        },
        {
            name: 'Vendor ID',
            selector: row => row.vendorId || '',
            sortable: true,
            sortField: 'vendorId',
            width: '120px'
        },
        {
            name: 'Product ID',
            selector: row => row.productId || '',
            sortable: true,
            sortField: 'productId',
            width: '120px'
        },
        {
            name: 'Type Slug',
            selector: row => row.typeSlug || row.type_slug || '',
            sortable: true,
            sortField: 'typeSlug',
            width: '140px'
        },
        {
            name: 'UID Prefix',
            selector: row => row.uidPrefix,
            sortable: true,
            sortField: 'uidPrefix',
            width: '120px'
        },
        {
            name: 'Catalog',
            selector: row => row.catalogName || '',
            sortable: true,
            sortField: 'catalogName',
            width: '120px'
        },
        {
            name: 'Category',
            selector: row => row.categoryName || '',
            sortable: true,
            sortField: 'categoryName',
            width: '120px'
        },
        {
            name: 'Device Model Group',
            selector: row => row.modelGroupName || '',
            sortable: true,
            sortField: 'modelGroupName',
            width: '150px'
        },
        {
            name: 'AWS Device Groups',
            selector: row => row.deviceGroups?.map(group => group.name).join(', ') || 'None',
            sortable: false,
            width: '200px',
            cell: (row) => {
                const groupNames = row.deviceGroups?.map(group => group.name).join(', ') || 'None';
                return (
                    <div
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={groupNames}
                    >
                        {groupNames.length > 20
                            ? `${groupNames.substring(0, 20)}...`
                            : groupNames}
                    </div>
                );
            },
        },
        {
            name: 'Policies',
            selector: row => row.policies?.map(policy => policy.name).join(', ') || 'None',
            sortable: false,
            width: '200px',
            cell: (row) => {
                const policyNames = row.policies?.map(policy => policy.name).join(', ') || 'None';
                return (
                    <div
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={policyNames}
                    >
                        {policyNames.length > 20
                            ? `${policyNames.substring(0, 20)}...`
                            : policyNames}
                    </div>
                );
            },
        },
        {
            name: 'Hub Required',
            selector: row => row.isHubRequired ? 'Yes' : 'No',
            sortable: true,
            sortField: 'isHubRequired',
            width: '100px',
            cell: (row) => (
                <span style={{ 
                    color: row.isHubRequired ? '#28a745' : '#dc3545',
                    fontWeight: 'bold'
                }}>
                    {row.isHubRequired ? 'Yes' : 'No'}
                </span>
            )
        },
        {
            name: 'Chime Compatible',
            selector: row => row.chime_compatible ? 'Yes' : 'No',
            sortable: true,
            sortField: 'chimeCompatible',
            width: '100px',
            cell: (row) => (
                <span style={{ 
                    color: row.chime_compatible ? '#28a745' : '#dc3545',
                    fontWeight: 'bold'
                }}>
                    {row.chime_compatible ? 'Yes' : 'No'}
                </span>
            )
        },
        {
            name: 'Group Compatible',
            selector: row => row.group_compatible ? 'Yes' : 'No',
            sortable: true,
            sortField: 'groupCompatible',
            width: '100px',
            cell: (row) => (
                <span style={{
                    color: row.group_compatible ? '#28a745' : '#dc3545',
                    fontWeight: 'bold'
                }}>
                    {row.group_compatible ? 'Yes' : 'No'}
                </span>
            )
        },
        {
            name: 'Scene Compatible',
            selector: row => row.scene_compatible ? 'Yes' : 'No',
            sortable: true,
            sortField: 'sceneCompatible',
            width: '100px',
            cell: (row) => (
                <span style={{
                    color: row.scene_compatible ? '#28a745' : '#dc3545',
                    fontWeight: 'bold'
                }}>
                    {row.scene_compatible ? 'Yes' : 'No'}
                </span>
            )
        },
        {
            name: 'Description',
            selector: row => row.description,
            sortable: true,
            sortField: 'description',
            width: '250px',
            cell: (row) => (
                <div
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={row?.description || ""}
                >
                    {row?.description && row.description.length > 20
                        ? `${row.description.substring(0, 20)}...`
                        : row?.description || ""}
                </div>
            ),
        },
        {
            name: 'Created Date',
            selector: row => row.createdOn,
            sortable: true,
            sortField: 'createdDate',
            width: '200px',
            cell: (row) => (
                <div style={{ width: "100%" }}>
                    {row.createdOn ? (
                        moment(row.createdOn).format("YYYY-MM-DD HH:mm:ss")
                    ) : (
                        <span style={{ marginLeft: "20%" }}>-</span>
                    )}
                </div>
            ),
        
        },
        {
            name: 'Actions',
            cell: renderActionCell,
            width: '100px'
        }
    ];

    const fetchDeviceModels = async () => {
        setLoading(true);
        try {
            const response = await getAllDeviceModels(page, perPage, sortField, sortOrder, searchValue);
            const models = (response?.data?.data?.content || []).filter(
                (model) => model && typeof model === "object" && model.id
            );
            setDeviceModels(models);
            setTotalRows(response?.data?.data?.totalElements || 0);
        } catch (error) {
            toast.error("Failed to fetch device models");
            setDeviceModels([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchCatalogs = async () => {
        try {
            const response = await getAllCatalogs(0, 100, 'id', 'asc', '');
            setCatalogs(response?.data?.data?.content || []);
        } catch (error) {
            toast.error("Failed to fetch catalogs");
        }
    };

    const fetchCategories = async (catalogId) => {
        if (!catalogId) {
            setCategories([]);
            return;
        }
        try {
            const response = await getCategoriesByCatalogId(catalogId, 0, 100, 'id', 'asc');
            setCategories(response?.data?.data?.content || []);
        } catch (error) {
            toast.error("Failed to fetch categories");
        }
    };

    const fetchModelGroups = async (categoryId) => {
        if (!categoryId) {
            setModelGroups([]);
            return;
        }
        try {
            const response = await getDeviceModelGroupsByCategoryId(categoryId, 0, 100, 'id', 'asc', '');
            setModelGroups(response?.data?.data?.content || []);
        } catch (error) {
            toast.error("Failed to fetch model groups");
        }
    };

    const fetchDeviceGroups = async (page = 0, search = '', append = false) => {
        setGroupsLoading(true);
        try {
            const response = await getAllDeviceGroups(page, groupsPageSize, 'id', 'desc', search);
            const newGroups = response?.data?.data?.content || [];
            const selectedGroupObjects = selectedGroups.filter(sg => 
                !newGroups.some(ng => ng.value === sg.value) && (!search || sg.label.toLowerCase().includes(search.toLowerCase()))
            ).map(sg => ({ id: sg.value, groupName: sg.label }));
            const combinedGroups = append ? [...groups, ...newGroups, ...selectedGroupObjects] : [...newGroups, ...selectedGroupObjects];
            setGroups(combinedGroups);
            return combinedGroups.map(group => ({
                value: group.id,
                label: group.groupName
            }));
        } catch (error) {
            toast.error("Failed to fetch AWS device groups");
            return [];
        } finally {
            setGroupsLoading(false);
        }
    };

    const loadGroupOptions = debounce(async (inputValue, callback) => {
        const options = await fetchDeviceGroups(0, inputValue, false);
        callback(options);
    }, 300);

    const fetchPolicies = async (page = 0, search = '', append = false, pagination = true) => {
        setPoliciesLoading(true);
        try {
            const response = await getAllDevicePolicies({
                pageNo: page,
                pageSize: policiesPageSize,
                sortBy: 'id',
                sortOrder: 'desc',
                searchValue: search,
                pagination: pagination,
            });
            const newPolicies = response?.data?.data?.policies || [];
            const selectedPolicyObjects = selectedPolicies.filter(sp => 
                !newPolicies.some(np => np.id === sp.value) && (!search || sp.label.toLowerCase().includes(search.toLowerCase()))
            ).map(sp => ({ id: sp.value, name: sp.label }));
            const combinedPolicies = append ? [...policies, ...newPolicies, ...selectedPolicyObjects] : [...newPolicies, ...selectedPolicyObjects];
            setPolicies(combinedPolicies);
            return combinedPolicies.map(policy => ({
                value: policy.id,
                label: policy.name
            }));
        } catch (error) {
            toast.error("Failed to fetch policies");
            return [];
        } finally {
            setPoliciesLoading(false);
        }
    };

    const loadPolicyOptions = debounce(async (inputValue, callback) => {
        const options = await fetchPolicies(0, inputValue, false, false);
        callback(options);
    }, 300);

    const handlePageChange = (newPage) => {
        setPage(newPage - 1);
        expectedPageRef.current = newPage - 1;
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
        setPage(0);
        expectedPageRef.current = 0;
    };

    const handleSort = (column, sortDirection) => {
        const sortFieldCol = column.sortField || column.selector || 'createdDate';
        setSortField(sortFieldCol);
        setSortOrder(sortDirection);
        setPage(0);
        expectedPageRef.current = 0;
    };

    const handleSearch = (event) => {
        setSearchValue(event.target.value);
        setPage(0);
        expectedPageRef.current = 0;
    };

    useEffect(() => {
        let isCancelled = false;

        const loadData = async () => {
            setLoading(true);
            try {
                if (!isCancelled) {
                    await fetchDeviceModels();
                }
            } catch (error) {
                if (!isCancelled) {
                    toast.error("Failed to fetch device models");
                    setDeviceModels([]);
                }
            } finally {
                if (!isCancelled) {
                    setLoading(false);
                }
            }
        };

        loadData();
        return () => {
            isCancelled = true;
        };
    }, [page, perPage, sortField, sortOrder, searchValue]);

    const handleAddNewClick = () => {
        setShowModal(true);
        setEditMode(false);
        setName('');
        setTypeSlug('');
        setDescription('');
        setUidPrefix('');
        setSelectedCatalogId('');
        setSelectedCategoryId('');
        setGroupId('');
        setSelectedGroupIds([]);
        setSelectedPolicyIds([]);
        setSelectedGroups([]);
        setSelectedPolicies([]);
        setGroups([]);
        setModelGroups([]);
        setPolicies([]);
        setVendorId('');
        setProductId('');
        setIsHubRequired(false);
        setgroup_compatible(false);
        setscene_compatible(false);
        fetchCatalogs();
        fetchPolicies(0, '', false, false);
        fetchDeviceGroups(0, '', false);
    };

    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowConfirmModal(true);
    };

    const confirmDelete = async () => {
        if (isDeleteDisabled || deleteId === null) return;
        setIsDeleteDisabled(true);
        try {
            await deleteDeviceModelById(deleteId);
            toast.success("Device Model deleted successfully!");
            setPage(0);
            expectedPageRef.current = 0;
            await fetchDeviceModels();
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || "Failed to delete Device Model");
        } finally {
            setIsDeleteDisabled(false);
            setDeleteId(null);
            setShowConfirmModal(false);
        }
    };

    const handleEditClick = (id) => {
        setCurrentModelId(id);
        const selectedModel = deviceModels.find((row) => row.id === id);
        setShowModal(true);
        setEditMode(true);
        const { name, typeSlug, type_slug, description, catalogId, categoryId, groupId, uidPrefix, catalogName, categoryName, modelGroupName, deviceGroups, policies, vendorId, productId, isHubRequired, chime_compatible, group_compatible, scene_compatible } = selectedModel;
        setName(name);
        setTypeSlug(typeSlug || type_slug || '');
        setDescription(description);
        setUidPrefix(uidPrefix || '');
        setSelectedCatalogId(catalogId);
        setSelectedCategoryId(categoryId);
        setGroupId(groupId);
        setSelectedGroups(deviceGroups.map(deviceGroup => ({
            value: deviceGroup.id,
            label: deviceGroup.name
        })));
        setSelectedPolicies(policies.map(policy => ({
            value: policy.id,
            label: policy.name
        })));
        const groupIds = deviceGroups.map(deviceGroup => deviceGroup.id);
        const policyIds = policies.map(policy => policy.id);
        setSelectedGroupIds(groupIds || []);
        setSelectedPolicyIds(policyIds || []);
        setCatalogsName(catalogName);
        setCategoryName(categoryName);
        setModelGroupName(modelGroupName);
        setVendorId(vendorId || '');
        setProductId(productId || '');
        setIsHubRequired(!!isHubRequired);
        setchime_compatible(!!chime_compatible);
        setgroup_compatible(!!group_compatible);
        setscene_compatible(!!scene_compatible);
    };

    const handleCatalogChange = (event) => {
        const catalogId = event.target.value;
        setSelectedCatalogId(catalogId);
        setSelectedCategoryId('');
        setGroupId('');
        setModelGroups([]);
        fetchCategories(catalogId);
    };

    const handleCategoryChange = (event) => {
        const categoryId = event.target.value;
        setSelectedCategoryId(categoryId);
        setGroupId('');
        setModelGroups([]);
        fetchModelGroups(categoryId);
    };

    const handleGroupChange = (selectedOptions) => {
        const selectedIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setSelectedGroupIds(selectedIds);
        setSelectedGroups(selectedOptions || []);
    };

    const handlePolicyChange = (selectedOptions) => {
        const selectedIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setSelectedPolicyIds(selectedIds);
        setSelectedPolicies(selectedOptions || []);
    };

    const handleTypeSlugKeyDown = (e) => {
        if (e.ctrlKey || e.metaKey || e.altKey) {
            return;
        }
        if (allowedKeys.includes(e.key)) {
            return;
        }

        const input = e.currentTarget;
        const selectionStart = input.selectionStart ?? 0;
        const selectionEnd = input.selectionEnd ?? 0;
        const replacingLength = selectionEnd - selectionStart;
        const nextLength = typeSlug.length - replacingLength + 1;

        if (nextLength > 50) {
            e.preventDefault();
            return;
        }

        const isLetter = /^[a-zA-Z]$/.test(e.key);
        const isValidBodyChar = /^[a-zA-Z0-9_]$/.test(e.key);

        if (selectionStart === 0 && !isLetter) {
            e.preventDefault();
            return;
        }

        if (!isValidBodyChar) {
            e.preventDefault();
        }
    };

    const handleTypeSlugChange = (e) => {
        const inputValue = e.target.value;
        const formattedValue = inputValue
            .toLowerCase()
            .replace(/[^a-z0-9_]/g, '')
            .replace(/^[^a-z]+/, '')
            .slice(0, 50);

        setTypeSlug(formattedValue);
    };

    const handleModalClose = () => {
        setShowModal(false);
        setValidationErrors({
            name: '',
            typeSlug: '',
            description: '',
            uidPrefix: '',
            groupId: '',
            policyIds: '',
            groupIds: '',
            vendorId: '',
            productId: ''
        });
        setName('');
        setTypeSlug('');
        setDescription('');
        setUidPrefix('');
        setSelectedCatalogId('');
        setSelectedCategoryId('');
        if (!editMode) {
            setGroupId('');
        }
        setSelectedGroupIds([]);
        setSelectedPolicyIds([]);
        setSelectedGroups([]);
        setSelectedPolicies([]);
        setCurrentModelId(null);
        setGroups([]);
        setModelGroups([]);
        setPolicies([]);
        setVendorId('');
        setProductId('');
        setIsHubRequired(false);
        setgroup_compatible(false);
        setscene_compatible(false);
    };

    const validateForm = () => {
        let isValid = true;
        const errors = {};
        if (!name || !/^[a-zA-Z ]+$/.test(name)) {
            errors.name = 'Name is required and can only contain letters';
            isValid = false;
        }
        if (!typeSlug) {
            errors.typeSlug = 'Please enter a type slug.';
            isValid = false;
        }
        if (!description) {
            errors.description = 'Description is required';
            isValid = false;
        }
        if (!editMode && !groupId) {
            errors.groupId = 'Group Name is required';
            isValid = false;
        }
        if (!uidPrefix || !/^[A-Z]{3}$/.test(uidPrefix)) {
            errors.uidPrefix = 'UID Prefix is required and must be exactly 3 letters (a-z or A-Z)';
            isValid = false;
        }
        if (!vendorId) {
            errors.vendorId = 'Vendor ID is required';
            isValid = false;
        }
        if (!productId) {
            errors.productId = 'Product ID is required';
            isValid = false;
        }
        if (selectedGroupIds.length > 10) {
            errors.groupIds = 'You can select up to 10 groups only';
            isValid = false;
        }
        if (selectedPolicyIds.length > 11) {
            errors.policyIds = 'You can select up to 11 policies only';
            isValid = false;
        }
        if (selectedPolicyIds.length < 1) { 
            errors.policyIds = 'At least 1 policy is required';
            isValid = false;
        }
        if (selectedGroupIds.length < 1) { 
            errors.groupIds = 'At least 1 group is required';
            isValid = false;
        }
        setValidationErrors(errors);
        return isValid;
    };

    const handleSave = async () => {
        if (!validateForm()) {
            return;
        }
        if (isSaveDisabled || (saveButtonRef.current && saveButtonRef.current.disabled)) return;
        if (saveButtonRef.current) {
            saveButtonRef.current.disabled = true;
        }
        setIsSaveDisabled(true);
        const updateModelPayload = {
            name,
            typeSlug,
            description,
            groupId,
            uidPrefix,
            deviceGroupIds: selectedGroupIds,
            policyIds: selectedPolicyIds,
            vendorId,
            productId,
            isHubRequired,
            chime_compatible,
            group_compatible,
            scene_compatible
        };
        const selectedCatalog = catalogs.find(
            (catalog) => String(catalog.id) === String(selectedCatalogId)
        );
        const selectedCategory = categories.find(
            (category) => String(category.id) === String(selectedCategoryId)
        );
        const createModelPayload = {
            name,
            typeSlug,
            description,
            uidPrefix,
            deviceGroupIds: selectedGroupIds,
            policyIds: selectedPolicyIds,
            vendorId,
            productId,
            isHubRequired,
            chime_compatible,
            group_compatible,
            scene_compatible,
            catelogName: selectedCatalog?.catalogName || catalogsName || '',
            categoryName: selectedCategory?.name || selectedCategory?.categoryName || categoryName || ''
        };
        try {
            if (editMode && currentModelId) {
                await updateDeviceModel(currentModelId, updateModelPayload);
                toast.success("Device Model updated successfully!");
            } else {
                await createDeviceModel(groupId, createModelPayload);
                toast.success("Device Model created successfully!");
            }
            setPage(0);
            expectedPageRef.current = 0;
            handleModalClose();
            await fetchDeviceModels();
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || "Failed to save Device Model");
        } finally {
            if (saveButtonRef.current) {
                saveButtonRef.current.disabled = false;
            }
            setIsSaveDisabled(false);
        }
    };

    return (
        <div className="custom_tab_wrapper">
            <style>
                {`
                    .btn_red {
                        background-color: #dc3545;
                        border-color: #dc3545;
                        color: white;
                    }
                    .btn_red:disabled {
                        background-color: #f28b94;
                        border-color: #f28b94;
                        color: white;
                        opacity: 0.8;
                    }
                    .btn_light__red {
                        background-color: #f8d7da;
                        border-color: #f5c6cb;
                        color: #721c24;
                    }
                    .btn_light__red:disabled {
                        background-color: #f8d7da;
                        border-color: #f5c6cb;
                        color: #721c24;
                        opacity: 0.65;
                    }
                    .react-select-container {
                        width: 100%;
                    }
                    .react-select__control {
                        border-color: #ced4da;
                        min-height: 38px;
                    }
                    .react-select__control--is-focused {
                        border-color: #4340d2;
                        box-shadow: 0 0 0 0.2rem rgba(67, 64, 210, 0.25);
                    }
                    .react-select__menu {
                        max-height: 200px;
                    }
                    .react-select__option--is-focused {
                        background-color: #f0f0f0;
                    }
                    .react-select__option--is-selected {
                        background-color: #4340d2;
                        color: white;
                    }
                    .invalid-react-select .react-select__control {
                        border-color: #dc3545;
                    }
                    .custom_table_action {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 10px;
                    }
                    .form-control.w-25 {
                        width: 25% !important;
                    }
                /* Make the table horizontally scrollable */
                .customs-table {
                  width: 100%;
                  overflow-x: auto;
                }
                /* Remove sticky from first column */
                /* .customs-table .rdt_TableCell:first-child,
                .customs-table .rdt_TableCol:first-child {
                  position: sticky !important;
                  left: 0;
                  background: #fff;
                  z-index: 10;
                  box-shadow: 2px 0 5px -2px #ccc;
                } */
                
                /* Sticky last column (Actions) - Header */
                .customs-table .rdt_TableCol:last-child {
                    position: sticky !important;
                    right: 0;
                    background: #fff !important;
                    z-index: 100 !important;
                    box-shadow: -2px 0 5px -2px #ccc;
                }

                /* Sticky last column (Actions) - Body cells */
                .customs-table .rdt_TableCell:last-child {
                    position: sticky !important;
                    right: 0;
                    background: #fff !important;
                    z-index: 9 !important;
                    box-shadow: -2px 0 5px -2px #ccc;
                }

                /* Ensure fixed header doesn't interfere */
                .customs-table .rdt_TableHeader {
                    z-index: 90 !important;
                }

                /* Ensure table head has proper z-index */
                .customs-table .rdt_TableHead {
                    z-index: 90 !important;
                }
                `}
            </style>

            <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button
                        className="nav-link active"
                        id="device-models-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#device-models"
                        type="button"
                        role="tab"
                        aria-controls="device-models"
                        aria-selected="true"
                    >
                        Device Models: {totalRows}
                    </button>
                </li>
            </ul>

            <div className="d-flex justify-content-between mb-2 custom_table_action">
                <input
                    className="form-control w-25"
                    type="text"
                    placeholder="Search by Name"
                    value={searchValue}
                    onChange={handleSearch}
                />
                <button
                    className="btn primary_btn"
                    onClick={handleAddNewClick}
                    data-bs-toggle="tooltip"
                    data-bs-placement="left"
                    title="Add New Device Model"
                >
                    <FontAwesomeIcon icon={faPlus} />
                </button>
            </div>

            <div className="h-100vh-150px">
                {loading ? (
                    <div className="spin-loader">
                        <Loader />
                    </div>
                ) : (
                    <div style={{ width: '100%', overflowX: 'auto' }}>
                        <div className="customs-table">
                            <DataTable
                                columns={columns}
                                data={deviceModels}
                                progressPending={loading}
                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                paginationPerPage={perPage} 
                                paginationDefaultPage={page + 1} 
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onSort={handleSort}
                                defaultSortFieldId={sortField} 
                                defaultSortAsc={sortOrder === 'asc'} 
                                sortServer
                                highlightOnHover
                                fixedHeader
                                fixedHeaderScrollHeight="440px"
                                paginationComponentOptions={{ 
                                    rowsPerPageText: 'Rows per page:',
                                    rangeSeparatorText: 'of',
                                    noRowsPerPage: false,
                                    selectAllRowsItem: false,
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>

            <Modal
                style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", marginTop: "10px", borderRadius: "5px", marginBottom: "20px" }}
                show={showModal}
                onHide={handleModalClose}
            >
                <Modal.Header closeButton>
                    <Modal.Title style={{ color: "#4340d2" }}>{editMode ? 'Edit Device Model' : 'Add Device Model'}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ width: "450px", maxHeight: "500px", overflowY: "auto" }}>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor='name'>Name<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                            <Form.Control
                                id='name'
                                type="text"
                                placeholder="Enter name"
                                value={name}
                                onKeyDown={(e) => {
                                    const isLetter = /^[a-zA-Z ]$/.test(e.key);
                                    if (!isLetter && !allowedKeys.includes(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => setName(e.target.value)}
                                isInvalid={!!validationErrors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                                {validationErrors.name}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor='uidPrefix'>UID Prefix<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                            <Form.Control
                                maxLength={3}
                                id='uidPrefix'
                                type="text"
                                placeholder="Enter UID Prefix"
                                value={uidPrefix}
                                onKeyDown={(e) => {
                                    const isLetter = /^[a-zA-Z]$/.test(e.key);
                                    if (!isLetter && !allowedKeys.includes(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    const onlyLetters = e.target.value.replace(/[^a-zA-Z]/g, '');
                                    setUidPrefix(onlyLetters.toUpperCase()); 
                                }}
                                isInvalid={!!validationErrors.uidPrefix}
                            />
                            <Form.Control.Feedback type="invalid">
                                {validationErrors.uidPrefix}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor='catalog'>Catalog<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                            {editMode ?
                                <Form.Control
                                    id="catalog"
                                    type='text'
                                    value={catalogsName}
                                    disabled={true}
                                />
                                :
                                <Form.Control
                                    id="catalog"
                                    as="select"
                                    value={selectedCatalogId}
                                    onChange={handleCatalogChange}
                                >
                                    <option value="">Select Catalog</option>
                                    {catalogs.map(catalog => (
                                        <option key={catalog.id} value={catalog.id}>
                                            {catalog.catalogName}
                                        </option>
                                    ))}
                                </Form.Control>
                            }
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor='category'>Category<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                            {editMode ?
                                <Form.Control
                                    id="category"
                                    type='text'
                                    value={categoryName}
                                    disabled={true}
                                />
                                :
                                <Form.Control
                                    id="category"
                                    as="select"
                                    value={selectedCategoryId}
                                    onChange={handleCategoryChange}
                                >
                                    <option value="">Select Category</option>
                                    {categories.map(category => (
                                        <option key={category.id} value={category.id}>
                                            {category.name}
                                        </option>
                                    ))}
                                </Form.Control>
                            }
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor='vendorId'>Vendor ID<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                            <Form.Control
                                id='vendorId'
                                type="text"
                                placeholder="Enter Vendor ID"
                                value={vendorId}
                                onChange={e => setVendorId(e.target.value)}
                                isInvalid={!!validationErrors.vendorId}
                            />
                            <Form.Control.Feedback type="invalid">
                                {validationErrors.vendorId}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor='productId'>Product ID<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                            <Form.Control
                                id='productId'
                                type="text"
                                placeholder="Enter Product ID"
                                value={productId}
                                onChange={e => setProductId(e.target.value)}
                                isInvalid={!!validationErrors.productId}
                            />
                            <Form.Control.Feedback type="invalid">
                                {validationErrors.productId}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor='typeSlug'>Type Slug<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                            <Form.Control
                                id='typeSlug'
                                type="text"
                                placeholder="Enter Type Slug"
                                maxLength={50}
                                value={typeSlug}
                                onKeyDown={handleTypeSlugKeyDown}
                                onChange={handleTypeSlugChange}
                                isInvalid={!!validationErrors.typeSlug}
                            />
                            <Form.Control.Feedback type="invalid">
                                {validationErrors.typeSlug}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor='deviceModelGroup'>Device Model Group<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                            {editMode ?
                                <Form.Control
                                    id='deviceModelGroup'
                                    type='text'
                                    value={modelGroupName}
                                    disabled={true}
                                />
                                :
                                <Form.Control
                                    id='deviceModelGroup'
                                    as="select"
                                    value={groupId}
                                    onChange={(e) => setGroupId(e.target.value)}
                                    isInvalid={!!validationErrors.groupId}
                                >
                                    <option value="">Select Group</option>
                                    {modelGroups.map(group => (
                                        <option key={group.id} value={group.id}>
                                            {group.name}
                                        </option>
                                    ))}
                                </Form.Control>
                            }
                            <Form.Control.Feedback type="invalid">
                                {validationErrors.groupId}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor='groupsMulti'>AWS Device Groups<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                            <div className={validationErrors.groupIds ? 'invalid-react-select' : ''}>
                                <AsyncSelect
                                    className="react-select"
                                    isMulti
                                    cacheOptions
                                    defaultOptions
                                    loadOptions={loadGroupOptions}
                                    onChange={handleGroupChange}
                                    value={selectedGroups}
                                    isLoading={groupsLoading}
                                    placeholder="Select Groups..."
                                />
                            </div>
                            {validationErrors.groupIds && (
                                <div className="invalid-feedback" style={{ display: 'block' }}>
                                    {validationErrors.groupIds}
                                </div>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor='policies'>Policies<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                            <div className={validationErrors.policyIds ? 'invalid-react-select' : ''}>
                                <AsyncSelect
                                    className="react-select"
                                    isMulti
                                    cacheOptions
                                    defaultOptions
                                    loadOptions={loadPolicyOptions}
                                    onChange={handlePolicyChange}
                                    value={selectedPolicies}
                                    isLoading={policiesLoading}
                                    placeholder="Select Policies..."
                                />
                            </div>
                            {validationErrors.policyIds && (
                                <div className="invalid-feedback" style={{ display: 'block' }}>
                                    {validationErrors.policyIds}
                                </div>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor='description'>Description<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                            <Form.Control
                                id='description'
                                as="textarea"
                                rows={4}
                                placeholder="Enter description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                isInvalid={!!validationErrors.description}
                            />
                            <Form.Control.Feedback type="invalid">
                                {validationErrors.description}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Row>
                                <Col xs={6}>
                                    <Form.Check
                                        type="checkbox"
                                        id="isHubRequired"
                                        label="Is Hub Required?"
                                        checked={isHubRequired}
                                        onChange={e => setIsHubRequired(e.target.checked)}
                                    />
                                </Col>
                                <Col xs={6}>
                                    <Form.Check
                                        type="checkbox"
                                        id="chime_compatible"
                                        label="Chime Compatible?"
                                        checked={chime_compatible}
                                        onChange={e => setchime_compatible(e.target.checked)}
                                    />
                                </Col>
                            </Row>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Row>
                                <Col xs={6}>
                                    <Form.Check
                                        type="checkbox"
                                        id="group_compatible"
                                        label="Group Compatible?"
                                        checked={group_compatible}
                                        onChange={e => setgroup_compatible(e.target.checked)}
                                    />
                                </Col>
                                <Col xs={6}>
                                    <Form.Check
                                        type="checkbox"
                                        id="scene_compatible"
                                        label="Scene Compatible?"
                                        checked={scene_compatible}
                                        onChange={e => setscene_compatible(e.target.checked)}
                                    />
                                </Col>
                            </Row>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn light_primary_btn me-3" onClick={handleModalClose}>
                        Cancel
                    </Button>
                    <Button
                        className="btn primary_btn"
                        type='submit'
                        onClick={handleSave}
                        ref={saveButtonRef}
                        disabled={isSaveDisabled}
                    >
                        {isSaveDisabled ? "Saving..." : "Save"}
                    </Button>
                </Modal.Footer>
            </Modal>

            {showConfirmModal && (
                <div
                    className="modal fade discard_modal show"
                    id="delete-model"
                    style={{ display: "block" }}
                    aria-hidden={!showConfirmModal}
                    aria-labelledby="exampleModalToggleLabel"
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <p className="modal-title" id="staticBackdropLabel">
                                    Delete Device Model
                                </p>
                            </div>
                            <div className="modal-body">
                                <p className="modal-msg-title">Confirm Delete</p>
                                <p className="modal-msg-desc">
                                    Are you sure you want to delete this device model?
                                </p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn_light__red mx-2"
                                    onClick={() => setShowConfirmModal(false)}
                                    disabled={isDeleteDisabled}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn_red btn-loader"
                                    onClick={confirmDelete}
                                    disabled={isDeleteDisabled}
                                >
                                    {isDeleteDisabled ? "Deleting..." : "Delete"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DeviceModel;